var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerk03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "57px",
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "perk-03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium",
    transform: "translate(-50, -1873)",
    fill: "#00467D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "perk-03",
    transform: "translate(50, 1873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5,57 C40.0318033,57 49.9639435,50.1510282 54.4505788,40.2989266 C56.0878909,36.7035897 57,32.7083121 57,28.5 C57,12.7598846 44.2401154,0 28.5,0 C12.7598846,0 0,12.7598846 0,28.5 C0,44.2401154 12.7598846,57 28.5,57 Z",
    id: "Oval-Copy-3",
    opacity: 0.227260045
  }), /*#__PURE__*/React.createElement("text", {
    id: 3,
    fontFamily: "AnekGurmukhi-SemiBold, Anek Gurmukhi",
    fontSize: 30,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 37
  }, "03.")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerk03);
export default __webpack_public_path__ + "static/media/perk-03.1b964989ec44237dc24a18f347437999.svg";
export { ForwardRef as ReactComponent };